import React from "react";
import PropTypes from 'prop-types';
import {
    financialProductConfigurationPropTypesShape,
    getFinancialTypeProductEIM,
} from "../../../helpers/financialProductConfigurationHelpers";
// import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getAppData} from "../../../store/slices/appSlice";
import CONST from "../../../config/CONST";
import FinancialProductSelection from "../../FinancialProductSelection/FinancialProductSelection";
import {getSelectedCustomer, getUserConfigurations} from "../../../store/slices/userConfigurationsSlice";

const FinancialProductsSelection = (props) => {

    const {
        financialProductConfiguration,
        onChange
    } = props;

    const appData = useSelector(getAppData);
    const selectedCustomer = useSelector(getSelectedCustomer) || appData.touchpointConfig.defaults.customer;
    let customersAvailable = appData.touchpointConfig.defaults.availableCustomer;
    const allUserConfigurations = useSelector(getUserConfigurations) || [];
    const userConfiguration = allUserConfigurations.find(c => c.modelID === appData.input.modelID && c.selectedProduct && c.customer === selectedCustomer);

    if(!appData || !userConfiguration || !financialProductConfiguration) {
        return null;
    }

    const _financialProducts = getFinancialTypeProductEIM(appData.modelsRatesMapping.find(c => c.EIM === appData.input.EIM), appData.input.vehicleType, customersAvailable[selectedCustomer], selectedCustomer).financialProducts;
    const _customerSelected = selectedCustomer || appData.touchpointConfig.defaults.customer;
    const _financialProductsForCustomer = appData.touchpointConfig.defaults.availableCustomer[_customerSelected];

    const _productCustomerIncluded = _financialProducts && _financialProducts.filter(product => _financialProductsForCustomer.includes(product.productTypeCode));

    return (
        <div className={`${CONST.CSS_NAMESPACE}FinancialProducts`}>
                {_productCustomerIncluded.map(productCustomer => {
                    if(productCustomer.rateID) {
                        return (
                            <FinancialProductSelection
                                product={productCustomer}
                                value={productCustomer.productTypeCode}
                                key={productCustomer.productTypeCode}
                                onChange={onChange}
                                checked={userConfiguration.selectedProduct || productCustomer[_customerSelected+`_defaultRentalProduct`]}
                            />
                        )
                    } else return null;
                })}
        </div>

    )
}

FinancialProductsSelection.propTypes = {
    financialProductConfiguration: PropTypes.shape(financialProductConfigurationPropTypesShape),
    onChange: PropTypes.func,
}

export default FinancialProductsSelection;